import { Component, OnInit, AfterViewInit } from '@angular/core';
import { TableData } from '../../md/md-table/md-table.component';
import { ClientLeadNoteEventLoaderService } from 'src/app/services/event-loaders/client-lead-note-event-loader.service';
import { FixedFormControlsService, ControlMode } from 'src/app/shared/fixed-form-controls/fixed-form-controls.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit, AfterViewInit {
    public tableData: TableData;

    constructor(public clientLeadNoteEventLoaderService: ClientLeadNoteEventLoaderService, fixedFormControlsService: FixedFormControlsService) {}

    ngOnInit() {}
    ngAfterViewInit() {}
}
